let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9SP4M")).then(() => parcelRequire('56U2f'));